module.exports = __webpack_public_path__ + "media/images/official/about_lead-b01dccb3e3cda875c8bdde66cf48fb3a.jpg";